import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore, isAuthenticated } from '@/store/useAuthStore';
import { useAutoRefreshToken } from '@/utils/useAutoRefreshToken';
import { isPlatformAllowed } from '@/utils/platform';
import NetworkIssueScreen from '@/components/NetworkIssueScreen';

export default function RequireAuth() {
  const authenticated = useAuthStore(isAuthenticated);
  const location = useLocation();

  useAutoRefreshToken(authenticated);

  // Re-syncs the merchant profile (and, with it, the environment's Collection API
  // credentials) once per session mount — login() already does this for a fresh
  // sign-in, but a session rehydrated from localStorage on page load never re-fetches
  // it otherwise, so merchantID/secretKey would only ever reflect a stale snapshot.
  useEffect(() => {
    if (authenticated) {
      useAuthStore.getState().fetchProfile().catch((err) => {
        // eslint-disable-next-line no-console
        console.error('[auth] fetchProfile failed', err);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);

  if (!authenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // A session persisted from an allowed platform can still be rehydrated on a
  // disallowed one — gate the actual app content here too, not just the login form.
  if (!isPlatformAllowed()) {
    return <NetworkIssueScreen />;
  }

  return <Outlet />;
}
